module.exports = __webpack_public_path__ + "static/media/NunitoSans-BoldItalic.d94ba8a9.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/NunitoSans-BoldItalic.eot
// module id = 3437
// module chunks = 70